(function() {
    'use strict';
    /*
     * Copyright (c) 2016 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .factory('personUtilities', personUtilities);

    personUtilities.$inject = ['Utilities'];

    function personUtilities(Utilities) {
        function getClinicProfessionalId (person, clinic) {
            var clinicProfessional = getClinicProfessional(person, clinic);
            var clinicProfessionalId = null;

            if (Utilities.isDefinedAndNotNull(clinicProfessional) &&
                    angular.isString(clinicProfessional.id)) {
                clinicProfessionalId = clinicProfessional.id;
            }

            return clinicProfessionalId;
        }

        function getClinicProfessional (person, clinic) {
            var activeClinicProfessional = null;
            if (angular.isArray(person.clinicProfessionals)) {
                var clinicProfessionalsCount = person.clinicProfessionals.length;
                for (var clinicProfessionalIndex = 0; clinicProfessionalIndex < clinicProfessionalsCount; clinicProfessionalIndex++) {
                    var clinicProfessional = person.clinicProfessionals[clinicProfessionalIndex];
                    var clinicProfessionalClinic = clinicProfessional.clinic;
                    if (angular.isDefined(clinicProfessionalClinic) &&
                                Utilities.isDefinedAndNotNull(clinicProfessionalClinic.id) &&
                                clinicProfessionalClinic.id === clinic.id) {
                        activeClinicProfessional = clinicProfessional;
                        break;
                    }
                }
            }

            return activeClinicProfessional;
        }

        function isMine(author, self, clinic) {
            return angular.isDefined(author) && author.id === getClinicProfessionalId(self, clinic);
        }

        return {
            getClinicProfessional: getClinicProfessional,
            getClinicProfessionalId: getClinicProfessionalId,
            isMine: isMine
        };
    }
})();
